export const testIds = {
  entityIdInput: 'entity-id-input',
  locationIdInput: 'location-id-input',
  auditDateInput: 'audit-date-input',
};
